// --------------------------------------------------
//   Imports
// --------------------------------------------------

// Material UI
import {
    Box,
    Button,
    Grid2 as Grid,
    Link,
    Stack,
    Typography,
} from "@mui/material";



// --------------------------------------------------
//   Main Component
// --------------------------------------------------


function Header() {

  const isFullscreen = false;

  const title = "Heartsong Choir";

  // Compute the header and footer heights
  const headerHeight = {
    xs: "120px",
    sm: "65px",
    md: "65px",
  }

  return (
    <Box
      component="header"
      sx={{
        height: headerHeight,
        width: "100%",
        borderBottom: "1px solid #D9D9D9",
        display: isFullscreen ? "none" : undefined,
      }}
    >
      <Stack
        direction="row" justifyContent="space-between" alignItems="center"
        columnGap={2} rowGap={0}
        height="100%"
        paddingX={4}
        position="relative"
        boxShadow="0px 2px 4px rgb(0 0 0 / 25%)"
        sx={{ flexWrap: { xs: "wrap", sm: "nowrap" } }}
      >

        <Box sx={{flexGrow: 1, order: {xs: 1, sm: "unset"}}}>
          <Typography variant="h1" fontSize={{xs: "16pt", sm: "20pt"}} lineHeight={1}>
            { title }
          </Typography>
        </Box>

        <Box sx={{height: {xs: "fit-content", sm: "62%"}, width: {xs: "42%", sm: "fit-content"}, flexShrink: 1, order: {xs: 0, sm: "unset"}, marginTop: "8px"}}>
          <Box
            component="img"
            alt="Bienen logo"
            src="/images/Horizontal-NW-BIENEN.png"
            sx={{
              display: "block",
              objectFit: "contain",
              width: {xs: "100%", sm: "auto"},
              height: {xs: "auto", sm: "100%"},
            }}
          />
        </Box>

        <Box sx={{height: {xs: "fit-content", sm: "100%"}, width: {xs: "42%", sm: "fit-content"}, flexShrink: 1, order: {xs: 0, sm: "unset"}}}>
          <Box
            component="img"
            alt="Lurie logo"
            src="/images/Lurie Color Logo.png"
            sx={{
              display: "block",
              objectFit: "contain",
              width: {xs: "100%", sm: "auto"},
              height: {xs: "auto", sm: "100%"},
            }}
          />
        </Box>

      </Stack>
    </Box>
  )
}



// --------------------------------------------------
//   Export(s)
// --------------------------------------------------

export default Header;
